// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2zy7s","info":"UpdateTermsInfo_info__3Ii05"};